<p-toast></p-toast>
<div class="farmer-data card">
  <div class="estimation-details">
    <form [formGroup]="estimationDetailsForm">
      <!-- <p class="pt-3 mx-2" [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{
        'Item Details' | translate }}</p> -->
      <marquee class="my-2" behavior="scroll" direction="left" style="color: red; font-weight: bold; font-size: 1rem;">All item price of selected MI-system/ programme is mandatory. Kindly ensure</marquee>
        
      <div class="p-fluid p-formgrid grid mx-2">

        <!-- <div class="field col-12 md:col-3 readonly">
          <label for="vendor">{{ "VENDOR_NAME" | translate }}</label>
          <input type="text" pInputText formControlName="vendor" readonly />
        </div> -->

        <!-- Mobile Number Field (Read-only) -->
        <!-- <div class="field col-3 readonly">
          <label for="mobileNo">Mobile</label>
          <input id="mobileNo" type="text" formControlName="mobileNo" pInputText readonly
            [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['mobileNo'].invalid && estimationDetailsForm.controls['mobileNo'].touched }" />
          <div *ngIf="estimationDetailsForm.get('mobileNo').invalid && estimationDetailsForm.get('mobileNo').touched"
            class="p-error">
            <small *ngIf="estimationDetailsForm.get('mobileNo').errors?.['pattern']">Invalid mobile number
              format.</small>
            <small *ngIf="estimationDetailsForm.controls['mobileNo'].errors.mobileNo">{{ "MOBILE_IS_INVALID" | translate
              }}</small>
          </div>
        </div> -->

        <!-- Email Field (Read-only) -->
        <!-- <div class="field col-12 md:col-3 readonly">
          <label for="email">{{ "EMAIL_ID" | translate }}</label>
          <input formControlName="email" readonly pInputText id="email" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['email'].invalid && estimationDetailsForm.controls['email'].touched }" />
          <div
            *ngIf="estimationDetailsForm.controls['email'].invalid && estimationDetailsForm.controls['email'].touched"
            class="p-error">
            <div *ngIf="estimationDetailsForm.controls['email'].errors.required">{{ "EMAIL_ID_IS_REQUIRED" | translate
              }}</div>
            <div *ngIf="estimationDetailsForm.controls['email'].errors.email">{{ "EMAIL_IS_INVALID" | translate }}</div>
          </div>
        </div> -->


        <div class="field col-12 md:col-3">
          <label htmlFor="selectProgram">{{'MI_SYSTEM'| translate}}</label>
          <div class="grid-item">
            <p-dropdown [options]="componentMasterList" formControlName="programmeName" optionLabel="Program_Name"
              (onChange)="onSelectProgramme()" placeholder="{{'SELECT_A_PROGRAMME' | translate}}" appendTo="body">
            </p-dropdown>
            <div
              *ngIf="estimationDetailsForm.controls['programmeName'].invalid && estimationDetailsForm.controls['programmeName'].touched"
              class="p-error">
              {{'PROGRAMME_NAME_IS_REQUIRED' | translate}}
            </div>
          </div>
        </div>

        <!-- <div class="field col-12 md:col-3">
          <label htmlFor="selectCategory">{{'CATEGORY_'| translate}}</label>
          <div class="grid-item">
            <p-dropdown [options]="category" formControlName="category" (onChange)="onSelectCategory()"
              placeholder="{{'SELECT_A_CATEGORY'| translate}}" optionLabel="categoryName" appendTo="body"></p-dropdown>
          </div>
          <div
            *ngIf="estimationDetailsForm.controls['category'].invalid && estimationDetailsForm.controls['category'].touched"
            class="p-error">
            {{'CATEGORY_IS_REQUIRED' | translate}}
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <label for="component">{{'COMPONENT'| translate}}</label>
          <div class="grid-item">
            <p-dropdown [options]="component" formControlName="component" (onChange)="onSelectComponent()"
              placeholder="{{'SELECT_A_COMPONENT'| translate}}" optionLabel="componentName"
              appendTo="body"></p-dropdown>
          </div>
          <div
            *ngIf="estimationDetailsForm.controls['component'].invalid && estimationDetailsForm.controls['component'].touched"
            class="p-error">
            {{'COMPONENT_IS_REQUIRED' | translate}}
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <label htmlFor="selectedSizePrice">{{'COMPONENT_SIZE'| translate}}</label>
          <div class="grid-item">
            <p-dropdown [options]="sizePrice" formControlName="sizePrice" (onChange)="onSelectSizePrice()"
              placeholder="{{'SELECT_SIZE'| translate}}" optionLabel="sizeOnly" appendTo="body"></p-dropdown>
          </div>
          <div
            *ngIf="estimationDetailsForm.controls['sizePrice'].invalid && estimationDetailsForm.controls['sizePrice'].touched"
            class="p-error">
            {{'SIZE_PRICE_IS_REQUIRED' | translate}}
          </div>
        </div> -->

        <div class="field col-12 md:col-9">
          <label>{{'Item Details'| translate}}</label>
          <div class="grid-item">
            <p-dropdown [options]="componentItemsListAfterFilter" formControlName="componentItem" (onChange)="onSelectListData()"
              placeholder="{{'SELECT'| translate}}" optionLabel="dataToShow" appendTo="body"></p-dropdown>
          </div>
          <div
            *ngIf="estimationDetailsForm.controls['componentItem'].invalid && estimationDetailsForm.controls['componentItem'].touched"
            class="p-error">
            {{'FIELD_IS_REQUIRED' | translate}}
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label for="cmlSerialNo">{{"CML_SERIAL_NO"|translate}}</label>
          <input formControlName="cmlSerialNo" pInputText id="block" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['cmlSerialNo'].invalid && estimationDetailsForm.controls['cmlSerialNo'].touched }" />

          <div
            *ngIf="estimationDetailsForm.controls['cmlSerialNo'].invalid && estimationDetailsForm.controls['cmlSerialNo'].touched"
            class="p-error">
            {{'CML_SERIAL_NO_IS_REQUIRED' | translate}}
          </div>
        </div>
        
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'CML_VALIDITY' | translate}}</label>
          <p-calendar [maxDate]="todayDate" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
            formControlName="cmlValidity" appendTo="body"
            [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['cmlValidity'].invalid && estimationDetailsForm.controls['cmlValidity'].touched }"></p-calendar>
          <div *ngIf="isSubmitted && estimationDetailsForm.controls['cmlValidity'].errors" class="invalid-feedback">
            <div *ngIf="estimationDetailsForm.controls['cmlValidity'].errors.required">{{'CML_VALIDITY_IS_REQUIRED' |
              translate}}</div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label for="name" class="ml-2">{{ "CML_CERTIFICATE" | translate }}</label>
          <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #cmlCertificateUpload (uploadHandler)="
                        onUpload($event, 'cmL_Certificate', cmlCertificateUpload)
                      " name="myfile[]" [maxFileSize]="5000000" [multiple]="false"
            chooseLabel="{{ 'CHOOSE' | translate }}" [auto]="false" [showCancelButton]="false">
          </p-fileUpload>
          <p-image *ngIf="estimationDetailsForm.value['cmL_Certificate']" [src]="estimationDetailsForm.value['cmL_Certificate']"
            alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
          <div *ngIf="isSubmitted && estimationDetailsForm.controls.cmL_Certificate.errors" class="invalid-feedback">
            <div *ngIf="estimationDetailsForm.controls.cmL_Certificate.errors.required">
              {{ "CHOOSE_AND_UPLOAD_CML_DOCUMENT" | translate }}
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-3">
          <label for="price">{{"PRICE"|translate}} (₹)</label>
          <input formControlName="price" pInputText id="block" type="number" onwheel="this.blur()"
            [ngClass]="{ 'ng-invalid ng-dirty': estimationDetailsForm.controls['price'].invalid && estimationDetailsForm.controls['price'].touched }" />

          <div
            *ngIf="estimationDetailsForm.controls['price'].invalid && estimationDetailsForm.controls['price'].touched"
            class="p-error">
            {{'PRICE_IS_REQUIRED' | translate}}
          </div>
        </div>
        <!-- <div class="field col-12 md:col-3">
          <label for="gstRate">{{"GST_RATE"|translate}}</label>
          <input type="number" pInputText formControlName="gstRate" readonly />
          <div
            *ngIf="estimationDetailsForm.controls['gstRate'].invalid && estimationDetailsForm.controls['gstRate'].touched"
            class="p-error">
            {{'GST_RATE_IS_REQUIRED' | translate}}
          </div>
        </div>

        <div class="field col-12 md:col-3">
          <label for="gstAmount">{{"GST_AMOUNT"|translate}}</label>
          <input type="number" pInputText formControlName="gstAmount" readonly />
          <div
            *ngIf="estimationDetailsForm.controls['gstAmount'].invalid && estimationDetailsForm.controls['gstAmount'].touched"
            class="p-error">
            {{'GST_AMOUNT_IS_REQUIRED' | translate}}
          </div>
        </div>

        <div class="field col-12 md:col-3">
          <label for="calculatedPrice">{{"CALCULATED_PRICE"|translate}} (₹)</label>
          <input type="number" pInputText formControlName="calculatedPrice" readonly />
        </div> -->
        <div class="field col-12 md:col-2">
          <label></label>
          <div class="grid-item mt-1">
            <button pButton pRipple type="submit" icon="pi pi-plus" label="{{'ADD'| translate}}"
              (click)="addEstimateData()" class="p-button-secondary mt-2 ml-5"
              style="width: 90px; height: 32px; align-items: center;">
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="estimationTableData.length > 0" class="card dashboardTable" style="margin: 5px;">
    <p-table [value]="estimationTableData" [rows]="10" [paginator]="false"
      [globalFilterFields]="[ 'programmeName', 'category', 'component', 'sizePrice', 'price', 'cmlSerialNo','cmlValidity','gstAmount','gstRate','calculatedPrice','Action']"
      responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>{{'S_NO'| translate}}</th>
          <!-- <th>{{'VENDOR_NAME'| translate}}</th> -->
          <th>{{'MI_SYSTEM'| translate}}</th>
          <th>{{'COMPONENT_CATEGORY'| translate}}</th>
          <th>{{'COMPONENT'| translate}}</th>
          <th>{{'COMPONENT_SIZE'| translate}}</th>
          <th>{{'CML_SERIAL_NO'| translate}}</th>
          <th>{{'CML_VALIDITY'| translate}}</th>
          <th>{{'PRICE'| translate}}</th>
          <!-- <th>{{'GST_RATE'| translate}}</th>
          <th>{{'GST_AMOUNT'| translate}}</th>
          <th>{{'CALCULATED_PRICE'| translate}}</th> -->
          <th>{{'ACTIONS'| translate}}</th>

        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
        <tr>
          <td>{{rowIndex + 1}}</td>
          <!-- <td>{{product.vendor}}</td> -->
          <td>{{product.MI_System_Name}}</td>
          <td>{{product.Component_Cat}}</td>
          <td>{{product.Component}}</td>
          <td>{{product.Component_Size}}</td>
          <td>{{product.CML_SrNo}}</td>
          <td>{{product.CML_Validity}}</td>
          <td>{{product.Price | currency: 'INR'}}</td>
          <!-- <td>{{product.gST_Rate}}</td>
          <td>{{product.gST_Amnt | currency: 'INR'}}</td>
          <td>{{product.calculated_Price | currency: 'INR'}}</td> -->
          <!-- <td>{{'RS.'| translate}} {{product.calculated_Price | number : '1.2-2'}}</td> -->
          <td>
            <button pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteEstimationRow(product, rowIndex)"
              class="p-button-rounded p-button-text p-button-danger"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div *ngIf="estimationTableData.length > 0" class="button-container-submit">
    <button pButton pRipple (click)="onSubmitFormConsent()" label="{{'SUBMIT' | translate}}" class="p-button-success"
      style="width: 100px; height: 32px; align-items: center;">
    </button>
  </div>
</div>
<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<div class="card mt-2 dashboardTable">

  <div *ngIf="!isAllDetailsAdded && VendorTableData?.length > 0" class="success-status mb-2">
    Note: <span>
      {{ 'All items added successfully.' | translate }}
    </span>
  </div>
  <div *ngIf="isAllDetailsAdded" class="failed-status mb-2">
    Note: <span>
      {{ 'All components are not added.' | translate }}
    </span>
  </div>

  <!-- <h5 [ngStyle]="{ 'font-weight': 'bold','display': 'flex', 'justify-content': 'space-around' }">
    {{ "Component Details" | translate }}
  </h5> -->

  <p-table #addedCompTable [value]="VendorTableData" [rows]="10" [paginator]="true" responsiveLayout="scroll"
    [rowHover]="true" dataKey="Mobile"
    currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
    [showCurrentPageReport]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}" [globalFilterFields]="[
    'MI_System_Name', 'Component_Cat', 'Component', 'Component_Size', 'Price', 'CML_SrNo', 'CML_Validity', 'CML_Certificate'
    ]">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
          <!-- Left side -->
          <div class="col-6 flex justify-content-start">
            <h5 [ngStyle]="{ 'font-weight': 'bold','display': 'flex', 'justify-content': 'space-around' }">
              {{ "Component Details" | translate }}
            </h5>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-1 d-flex justify-content-between">
              <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button>
              <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
              <p-menu #menu [popup]="true" [model]="addedCompTableExport"></p-menu>
          </div>
          <!-- Right side for search -->
          <div class="col-5 d-flex align-items-center justify-content-end">
              <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" (input)="addedCompTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
              </span>
          </div>
      </div>
  </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>{{'S_NO'| translate}}</th>
        <!-- <th pSortableColumn="VendorId">{{'VendorId'| translate}}</th> -->
        <!-- <th pSortableColumn="VendorName">{{'Vendor Name'| translate}}</th> -->
        <th pSortableColumn="MI_System_Name">{{'MI_SYSTEM'| translate}}</th>
        <th pSortableColumn="Component_Cat">{{'CATEGORY_'| translate}}</th>
        <th pSortableColumn="Component">{{'COMPONENT'| translate}}</th>
        <th pSortableColumn="Component_Size">{{'COMPONENT_SIZE'| translate}}</th>
        <th pSortableColumn="Price">{{'PRICE'| translate}}</th>
        <!-- <th pSortableColumn="GST_Rate">{{'GST_RATE'| translate}}</th>
        <th pSortableColumn="GST_Amnt">{{'GST_AMOUNT'| translate}}</th>
        <th pSortableColumn="Calculated_Price">{{'CALCULATED_PRICE'| translate}}</th> -->
        <th pSortableColumn="CML_SrNo">{{'CML Sr No'| translate}}</th>
        <th pSortableColumn="CML_Validity">{{'CML Validity'| translate}}</th>
        <th pSortableColumn="CML_Certificate">{{'CML Certificate'| translate}}</th>
        <!-- <th pSortableColumn="Mobile">{{'Mobile'| translate}}</th> -->
        <th>{{'ACTIONS'| translate}}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-consolidateData let-Index="rowIndex">
      <tr class="body-section">
        <td>{{ Index + 1 }}</td>
        <!-- <td>{{consolidateData?.VendorId}}</td> -->
        <!-- <td>{{consolidateData?.VendorName}}</td> -->
        <td>{{consolidateData?.MI_System_Name}}</td>
        <td>{{consolidateData?.Component_Cat}}</td>
        <td>{{consolidateData?.Component}}</td>
        <td>{{consolidateData?.Component_Size}}</td>
        <td>{{consolidateData.Price | currency: 'INR'}}</td>
        <!-- <td>{{consolidateData.GST_Rate}}</td>
        <td>{{consolidateData.GST_Amnt | currency: 'INR'}}</td>
        <td>{{consolidateData.Calculated_Price | currency: 'INR'}}</td> -->
        <td>{{consolidateData?.CML_SrNo }}</td>
        <td>{{consolidateData?.CML_Validity | date:'mediumDate'}}</td>
        <!-- <td>{{consolidateData?.CML_Certificate}}</td> -->
        <td>
          <a *ngIf="consolidateData?.CML_Certificate && consolidateData?.CML_Certificate != 'string'"
          style="cursor: pointer" icon="pi pi-eye" [href]="consolidateData?.CML_Certificate" target="_blank">
          <button pButton type="button" class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
          pTooltip="View" icon="pi pi-eye"></button>
          </a>
        </td>
        <td>
          <button pButton pRipple type="button" icon="pi pi-trash" (click)="onDeleteAddedCompRow(consolidateData, Index)"
            class="p-button-rounded p-button-text p-button-danger"></button>
        </td>
        <!-- <td>{{consolidateData?.Mobile}}</td> -->
        <!-- <td>{{consolidateData?.Calculated_Price | number : '1.2-2'}}</td> -->
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">

    </ng-template>

  </p-table>
</div>

<p-confirmdialog></p-confirmdialog>
